export function calculateCoinDashScore(coins: number, height: number) {
    return Math.floor(Math.floor(coins) * Math.floor(height));
}
